export interface PurchaseNotification {
  name: string
  country: string
  flag: string
}

export const purchaseNotifications: PurchaseNotification[] = [
  { name: 'Dr. Lucía Fernández', country: 'Madrid, Spain', flag: '🇪🇸' },
  { name: 'Dr. Carlos Medina', country: 'Bogotá, Colombia', flag: '🇨🇴' },
  { name: 'Dra. Valeria Rojas', country: 'Santiago, Chile', flag: '🇨🇱' },
  { name: 'Dr. Andrés Gutiérrez', country: 'Mexico City, Mexico', flag: '🇲🇽' },
  { name: 'Dra. Paula Sánchez', country: 'Buenos Aires, Argentina', flag: '🇦🇷' },
  { name: 'Dr. Miguel Ángel Torres', country: 'Lima, Peru', flag: '🇵🇪' },
  { name: 'Dra. Camila Herrera', country: 'Quito, Ecuador', flag: '🇪🇨' },
  { name: 'Dr. Javier Morales', country: 'San José, Costa Rica', flag: '🇨🇷' },
  { name: 'Dra. Isabel Navarro', country: 'Montevideo, Uruguay', flag: '🇺🇾' },
  { name: 'Dr. Rafael Domínguez', country: 'Santo Domingo, Dominican Rep.', flag: '🇩🇴' },
  { name: 'Dra. Mariana Castillo', country: 'Guatemala City, Guatemala', flag: '🇬🇹' },
  { name: 'Dr. Sergio Vargas', country: 'Miami, United States', flag: '🇺🇸' },
]
